/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Prefer Language
 */
export type EditUserRequestPreferLanguage = typeof EditUserRequestPreferLanguage[keyof typeof EditUserRequestPreferLanguage];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EditUserRequestPreferLanguage = {
  'en-US': 'en-US',
  'zh-HK': 'zh-HK',
  'zh-CN': 'zh-CN',
  'ja-JP': 'ja-JP',
} as const;
